// All colors match backend STYLE_COLORS exactly
export const websiteTemplates = [
  {
    id: 'modern',    name: 'Modern Professional',
    description: 'Deep navy + electric blue. Clean and versatile.',
    preview: 'https://images.unsplash.com/photo-1460925895917-afdab827c52f?w=400&h=300&fit=crop',
    bg: '#0d1117', primary: '#3b82f6', secondary: '#6366f1', textCol: '#f1f5f9',
    free: true
  },
  {
    id: 'creative',  name: 'Creative Studio',
    description: 'Dark purple + coral red & yellow. Bold and artistic.',
    preview: 'https://images.unsplash.com/photo-1561070791-2526d30994b5?w=400&h=300&fit=crop',
    bg: '#12002a', primary: '#ff6b6b', secondary: '#ffd93d', textCol: '#f8f4ff',
    free: true
  },
  {
    id: 'corporate', name: 'Corporate Elite',
    description: 'Navy + steel blue & amber. Professional and trustworthy.',
    preview: 'https://images.unsplash.com/photo-1486406146926-c627a92ad1ab?w=400&h=300&fit=crop',
    bg: '#0f1b2d', primary: '#1d6fa4', secondary: '#56cfe1', textCol: '#e8f1f5',
    free: true
  },
  {
    id: 'startup',   name: 'Startup Launch',
    description: 'Dark + cyan & purple. Dynamic and high-tech.',
    preview: 'https://images.unsplash.com/photo-1557804506-669a67965ba0?w=400&h=300&fit=crop',
    bg: '#0a0f1e', primary: '#00d4ff', secondary: '#7b2ff7', textCol: '#f0f4ff',
    free: false
  },
  {
    id: 'restaurant', name: 'Restaurant Elegant',
    description: 'Dark warm + burnt orange & amber. Rich dining feel.',
    preview: 'https://images.unsplash.com/photo-1517248135467-4c7edcad34c4?w=400&h=300&fit=crop',
    bg: '#1a0a00', primary: '#e85d04', secondary: '#f48c06', textCol: '#f5f0e8',
    free: false
  },
  {
    id: 'portfolio',  name: 'Creative Portfolio',
    description: 'Black + hot pink & violet. Eye-catching showcase.',
    preview: 'https://images.unsplash.com/photo-1542744094-3a31f272c490?w=400&h=300&fit=crop',
    bg: '#0d0d0d', primary: '#f72585', secondary: '#7209b7', textCol: '#ffffff',
    free: false
  },
  {
    id: 'ecommerce',  name: 'E-commerce Store',
    description: 'Dark + sky blue & royal blue. Product-focused.',
    preview: 'https://images.unsplash.com/photo-1472851294608-062f824d29cc?w=400&h=300&fit=crop',
    bg: '#0f1923', primary: '#4cc9f0', secondary: '#4361ee', textCol: '#e9ecef',
    free: false
  },
  {
    id: 'medical',    name: 'Medical Professional',
    description: 'Deep navy + cyan & violet. Clean and trustworthy.',
    preview: 'https://images.unsplash.com/photo-1519494026892-80bbd2d6fd0d?w=400&h=300&fit=crop',
    bg: '#071e3d', primary: '#21d4fd', secondary: '#b721ff', textCol: '#e8f4ff',
    free: false
  },
  {
    id: 'agency',     name: 'Digital Agency',
    description: 'Very dark + crimson & violet. Bold and edgy.',
    preview: 'https://images.unsplash.com/photo-1557804506-669a67965ba0?w=400&h=300&fit=crop',
    bg: '#080010', primary: '#ff4d6d', secondary: '#c77dff', textCol: '#fff0f3',
    free: false
  },
  {
    id: 'luxury',     name: 'Luxury Brand',
    description: 'Near-black + gold & dark gold. Premium and elegant.',
    preview: 'https://images.unsplash.com/photo-1542744173-8e7e53415bb0?w=400&h=300&fit=crop',
    bg: '#0a0800', primary: '#d4af37', secondary: '#b8860b', textCol: '#fdf6e3',
    free: false
  }
];

export const industries = [
  { id: 'general',     name: 'General Business',         icon: '🏢', keywords: 'professional, reliable, quality service' },
  { id: 'fitness',     name: 'Fitness & Gym',             icon: '🏋️', keywords: 'training, health, strength, wellness' },
  { id: 'restaurant',  name: 'Restaurant & Food',         icon: '🍽️', keywords: 'delicious, fresh, dining experience' },
  { id: 'salon',       name: 'Salon & Beauty',            icon: '💅', keywords: 'beauty, style, professional care' },
  { id: 'medical',     name: 'Medical & Healthcare',      icon: '🏥', keywords: 'trusted, professional, caring health services' },
  { id: 'retail',      name: 'Retail & E-commerce',       icon: '🛍️', keywords: 'shopping, products, customer satisfaction' },
  { id: 'tech',        name: 'Technology & Software',     icon: '💻', keywords: 'innovative, cutting-edge, digital transformation' },
  { id: 'real_estate', name: 'Real Estate',               icon: '🏠', keywords: 'homes, properties, trusted agent' },
  { id: 'creative',    name: 'Creative & Design',         icon: '🎨', keywords: 'creative, artistic, design studio' },
  { id: 'professional',name: 'Professional Services',     icon: '💼', keywords: 'expert advice, consulting, solutions' },
];

export const generateWebsiteHTML = (data, template, isPremium = false) => {
  const { businessName, businessDescription, industry, contactEmail, contactPhone } = data;
  const industryInfo = industries.find(i => i.id === industry) || industries[0];
  
  const colors = {
    modern: { primary: '#3B82F6', secondary: '#1E40AF', accent: '#60A5FA' },
    creative: { primary: '#8B5CF6', secondary: '#6D28D9', accent: '#A78BFA' },
    corporate: { primary: '#1F2937', secondary: '#111827', accent: '#4B5563' }
  };
  
  const themeColors = colors[template] || colors.modern;
  
  return `<!DOCTYPE html>
<html lang="en">
<head>
    <meta charset="UTF-8">
    <meta name="viewport" content="width=device-width, initial-scale=1.0">
    <title>${businessName} - ${industryInfo.name}</title>
    <meta name="description" content="${businessDescription}">
    <style>
        * {
            margin: 0;
            padding: 0;
            box-sizing: border-box;
        }
        
        body {
            font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, sans-serif;
            line-height: 1.6;
            color: #333;
        }
        
        .container {
            max-width: 1200px;
            margin: 0 auto;
            padding: 0 20px;
        }
        
        header {
            background: linear-gradient(135deg, ${themeColors.primary} 0%, ${themeColors.secondary} 100%);
            color: white;
            padding: 60px 0;
            text-align: center;
        }
        
        header h1 {
            font-size: 3em;
            margin-bottom: 20px;
            animation: fadeIn 1s ease-in;
        }
        
        header p {
            font-size: 1.3em;
            opacity: 0.95;
        }
        
        .industry-badge {
            display: inline-block;
            background: rgba(255,255,255,0.2);
            padding: 8px 20px;
            border-radius: 25px;
            margin-top: 15px;
            font-size: 0.9em;
        }
        
        section {
            padding: 80px 0;
        }
        
        .about {
            background: #f8f9fa;
        }
        
        .about h2 {
            font-size: 2.5em;
            margin-bottom: 30px;
            color: ${themeColors.primary};
            text-align: center;
        }
        
        .about p {
            font-size: 1.2em;
            max-width: 800px;
            margin: 0 auto;
            text-align: center;
            line-height: 1.8;
        }
        
        .features {
            background: white;
        }
        
        .features h2 {
            font-size: 2.5em;
            margin-bottom: 50px;
            text-align: center;
            color: ${themeColors.primary};
        }
        
        .features-grid {
            display: grid;
            grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
            gap: 40px;
            margin-top: 40px;
        }
        
        .feature-card {
            padding: 30px;
            background: #f8f9fa;
            border-radius: 10px;
            text-align: center;
            transition: transform 0.3s ease, box-shadow 0.3s ease;
        }
        
        .feature-card:hover {
            transform: translateY(-10px);
            box-shadow: 0 10px 30px rgba(0,0,0,0.1);
        }
        
        .feature-icon {
            font-size: 3em;
            margin-bottom: 20px;
        }
        
        .feature-card h3 {
            font-size: 1.5em;
            margin-bottom: 15px;
            color: ${themeColors.primary};
        }
        
        .contact {
            background: ${themeColors.primary};
            color: white;
            text-align: center;
        }
        
        .contact h2 {
            font-size: 2.5em;
            margin-bottom: 30px;
        }
        
        .contact-info {
            font-size: 1.2em;
            margin: 20px 0;
        }
        
        .contact-info a {
            color: white;
            text-decoration: none;
            border-bottom: 2px solid rgba(255,255,255,0.3);
            transition: border-color 0.3s ease;
        }
        
        .contact-info a:hover {
            border-bottom-color: white;
        }
        
        .cta-button {
            display: inline-block;
            padding: 15px 40px;
            background: white;
            color: ${themeColors.primary};
            text-decoration: none;
            border-radius: 50px;
            font-weight: bold;
            font-size: 1.1em;
            margin-top: 30px;
            transition: transform 0.3s ease, box-shadow 0.3s ease;
        }
        
        .cta-button:hover {
            transform: scale(1.05);
            box-shadow: 0 10px 30px rgba(0,0,0,0.2);
        }
        
        footer {
            background: #1a1a1a;
            color: white;
            text-align: center;
            padding: 30px 0;
            font-size: 0.9em;
        }
        
        .powered-by {
            margin-top: 15px;
            opacity: 0.7;
            font-size: 0.85em;
        }
        
        @keyframes fadeIn {
            from { opacity: 0; transform: translateY(20px); }
            to { opacity: 1; transform: translateY(0); }
        }
        
        @media (max-width: 768px) {
            header h1 { font-size: 2em; }
            .features-grid { grid-template-columns: 1fr; }
        }
    </style>
</head>
<body>
    <header>
        <div class="container">
            <h1>${businessName}</h1>
            <p>${businessDescription}</p>
            <div class="industry-badge">${industryInfo.icon} ${industryInfo.name}</div>
        </div>
    </header>

    <section class="about">
        <div class="container">
            <h2>About Us</h2>
            <p>
                Welcome to ${businessName}! We are dedicated to providing exceptional ${industryInfo.keywords}. 
                ${businessDescription} Our commitment to excellence and customer satisfaction sets us apart.
            </p>
        </div>
    </section>

    <section class="features">
        <div class="container">
            <h2>What We Offer</h2>
            <div class="features-grid">
                <div class="feature-card">
                    <div class="feature-icon">⚡</div>
                    <h3>Fast & Reliable</h3>
                    <p>Quick turnaround times with consistent, high-quality results</p>
                </div>
                <div class="feature-card">
                    <div class="feature-icon">🎯</div>
                    <h3>Focused Solutions</h3>
                    <p>Tailored services that meet your specific needs</p>
                </div>
                <div class="feature-card">
                    <div class="feature-icon">💎</div>
                    <h3>Premium Quality</h3>
                    <p>Excellence in every detail, guaranteed satisfaction</p>
                </div>
            </div>
        </div>
    </section>

    <section class="contact">
        <div class="container">
            <h2>Get In Touch</h2>
            <p>Ready to work with us? Contact us today!</p>
            ${contactEmail ? `<div class="contact-info">📧 Email: <a href="mailto:${contactEmail}">${contactEmail}</a></div>` : ''}
            ${contactPhone ? `<div class="contact-info">📞 Phone: <a href="tel:${contactPhone}">${contactPhone}</a></div>` : ''}
            <a href="#" class="cta-button">Contact Us Now</a>
        </div>
    </section>

    <footer>
        <div class="container">
            <p>&copy; ${new Date().getFullYear()} ${businessName}. All rights reserved.</p>
            <p class="powered-by">Website powered by <strong>globalnow.biz</strong> - AI Website Generator</p>
            ${!isPremium ? '<p style="margin-top: 10px; font-size: 0.8em; opacity: 0.6;">⭐ Upgrade for custom domains, SEO optimization & more!</p>' : ''}
        </div>
    </footer>
</body>
</html>`;
};